/**
 * useMediaPlaybackShare
 */

import { useMemo } from 'react';

import {
    ApolloLib,
    Fragments,
} from 'bdvp-graphql';

const { useApolloClient } = ApolloLib;
const { MEDIA_PLAYBACK_SHARE } = Fragments;

const useMediaPlaybackShare = (id) => {

    const client = useApolloClient();

    const mediaPlayback = useMemo(() => client.readFragment({
        id: `MediaPlayback:${id}`,
        fragment: MEDIA_PLAYBACK_SHARE,
    }), [
        id,
        client,
    ]);

    return mediaPlayback;

};

export default useMediaPlaybackShare;
